import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import styles from './PreviewUnavailable.module.scss'

export const PreviewUnavailable = memo(() => {
  const { t } = useTranslation('translation', { keyPrefix: 'desktop' })

  return (
    <div className={styles.container}>
      <span>{t('preview-unavailable')}</span>
    </div>
  )
})
